import { Routes, Route, Navigate } from 'react-router-dom';
import { Landing } from './pages/Landing.js';
import { Login } from './pages/Login.js';
import { AuthVerify } from './pages/AuthVerify.js';
import { Voter } from './pages/Voter.js';
import { AppShell } from './pages/AppShell.js';
import { Dashboard } from './pages/Dashboard.js';
import { Signup } from './pages/Signup.js';
import { Residents } from './pages/Residents.js';
import { Lots } from './pages/Lots.js';
import { Elections } from './pages/Elections.js';
import { ElectionDetail } from './pages/ElectionDetail.js';
import { Settings } from './pages/Settings.js';
import { Verify } from './pages/Verify.js';
import { AuditLog } from './pages/AuditLog.js';
import { Super } from './pages/Super.js';

export function App() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/login" element={<Login />} />
      <Route path="/auth/verify" element={<AuthVerify />} />
      <Route path="/vote/:token" element={<Voter />} />
      <Route path="/verify" element={<Verify />} />
      <Route path="/app" element={<AppShell />}>
        <Route index element={<Dashboard />} />
        <Route path="residents" element={<Residents />} />
        <Route path="lots" element={<Lots />} />
        <Route path="elections" element={<Elections />} />
        <Route path="elections/:id" element={<ElectionDetail />} />
        <Route path="settings" element={<Settings />} />
        <Route path="audit" element={<AuditLog />} />
        <Route path="super" element={<Super />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
